import { useState } from "react";
import { useTranslation } from "react-i18next";

interface UseClaimModalReturn {
    showModal: boolean;
    modalData: {
        title: string;
        subtitle: string;
        subtitle2: string;
        countValues: number;
        bodyLabel: string;
        type: 'delete' | 'end' | 'info' | 'upload' | 'exportCsv';
    };
    error: string;
    endDate: Date | null;
    startDate: Date | null;
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
    closeModal: () => void;
    setEndDate: (date: Date | null) => void;
    setStartDate: (date: Date | null) => void;
    setError: (error: string) => void;
    onEndDateChange?: (date: Date | null) => void;
    openUploadModal: () => void; // Added upload modal function
    setModalCount: (count: number) => void; // ADDED: New function to update the count

}

export function useClaimModal(): UseClaimModalReturn {
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(null);

    const { t } = useTranslation('claim');

    const [modalData, setModalData] = useState<{
        title: string;
        subtitle: string;
        subtitle2: string;
        countValues: number,
        bodyLabel: string;
        type: 'delete' | 'end' | 'info' | 'upload' |'exportCsv';
    }>({
        title: "default",
        subtitle: "default",
        subtitle2: "default",
        countValues: 0,
        bodyLabel: "default",
        type: "info"
    });

    // New function for upload modal
    const openUploadModal = () => {

        setShowModal(true);
        setModalData({
            title: t("claim:modal.claimModalInfoTitle"),
            subtitle: t("claim:modal.claimModalInfoDescription"),
            subtitle2: "",
            bodyLabel: "",
            type: "exportCsv",
            countValues: 0
        });
    };
  
    const closeModal = () => {
        setIsLoading(false); // Reset loading state al cerrar
        setShowModal(false);
        setError('')
    };

    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    const setModalCount = (count: number) => {
        setModalData(prevData => ({ ...prevData, countValues: count }));
    };

    return {
        showModal,
        modalData,
        error,
        endDate,
        startDate,
        openUploadModal,
        closeModal,
        setEndDate,
        setStartDate,
        setError,
        isLoading,
        setLoading,
        setModalCount
    };
}
